export default __webpack_public_path__ + "static/media/AcornMallCarpark_15.14757444.png";